if (!customElements.get("collection-variant-selects")) {
	customElements.define(
		"collection-variant-selects",
		class CollectionVariantSelects extends HTMLElement {
			connectedCallback() {
				this.addEventListener("change", event => {
					const target = event.target
					if (target.tagName !== "INPUT" || target.type !== "radio") return

					publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
						data: {
							event,
							target,
							selectedOptionValues: []
						}
					})

					scrollTo({
						top: 0,
						behavior: "smooth"
					})
				})
			}
		}
	)
}
